import { memo } from 'react';
import { CardData } from '../../../../../types';

interface InputFieldProps {
    cardNum: 1 | 2;
    idSuffix: string;
    label: string;
    field: keyof CardData;
    value: string;
    placeholder: string;
    disabled: boolean;
    onChange: (cardNum: 1 | 2, field: keyof CardData, value: string) => void;
}

export const InputField = memo(({
    cardNum,
    idSuffix,
    label,
    field,
    value,
    placeholder,
    disabled,
    onChange,
}: InputFieldProps) => (
    <div className="input-group">
        <label htmlFor={`card-${cardNum}-${idSuffix}`}>{label}</label>
        <input
            id={`card-${cardNum}-${idSuffix}`}
            type="text"
            value={value}
            onChange={(e) => onChange(cardNum, field, e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            className="form-control"
        />
    </div>
));
